module.exports = __webpack_public_path__ + "static/media/BentonSans-Book.267ee7b1.otf";